import _isNumber from "lodash/isNumber";
export function calculateCentroid(coord) {
  if (_isNumber(coord[0])) {
    return coord;
  } else if (_isNumber(coord[0][0])) {
    throw new Error('当前数据不支持标注');
  } else if (_isNumber(coord[0][0][0])) {
    var coords = coord;
    var xSum = 0;
    var ySum = 0;
    var len = 0;
    coords.forEach(function (coor) {
      coor.forEach(function (pos) {
        xSum += pos[0];
        ySum += pos[1];
        len++;
      });
    });
    return [xSum / len, ySum / len, 0];
  } else {
    throw new Error('当前数据不支持标注');
  }
}
export function calculatePointsCenterAndRadius(points) {
  var maxX = points[0];
  var maxY = points[1];
  var minX = points[0];
  var minY = points[1];
  var xCount = 0;
  var yCount = 0;
  var pCount = 0;

  for (var i = 0; i < points.length; i += 2) {
    var x = points[i];
    var y = points[i + 1];

    if (x && y) {
      maxX = Math.max(x, maxX);
      maxY = Math.max(y, maxY);
      minX = Math.min(x, minX);
      minY = Math.min(y, minY);
      xCount += x;
      yCount += y;
      pCount++;
    }
  }

  return {
    center: [xCount / pCount, yCount / pCount],
    radius: Math.sqrt(Math.pow(maxX - minX, 2) + Math.pow(maxY - minY, 2)) / 2
  };
}
//# sourceMappingURL=geo.js.map